import { render, staticRenderFns } from "./ClinicalMenu.vue?vue&type=template&id=b3083e14"
import script from "./ClinicalMenu.vue?vue&type=script&lang=js"
export * from "./ClinicalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports